import styled, { keyframes } from 'styled-components'

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ChartHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ChartHeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const ChartHeaderValue = styled.span`
  font-size: 16px;
  margin: 0;
  font-weight: 700;
  color: white;
`

export const Tabs = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  border-radius: 14px;
  display: flex;
  gap: 2px;
`

export const StyledTabButton = styled.button<{ isActive?: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  border: none;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: white;
  padding: 6px 10px;
  border-radius: 14px;
  font-weight: 500;
  font-size: 12px;
  transition: all 300ms;
  background: ${({ isActive }) => (isActive ? '#4AFC38' : 'transparent')};
  color: ${({ isActive }) => (isActive ? 'black' : 'white')};

  &:hover {
    color: #4afc38;
  }

  ${({ isActive }) =>
    isActive &&
    `
      &:hover {
        color: black !important;
      }
    `}
`

export const RechartsWrapper = styled.div`
  animation: ${fadeUp} 0.5s ease-out;
  cursor: default;
  width: 100%;
  height: 250px;
  max-height: 250px;
  padding: 16px;
  border-radius: 14px;
  background: ${({ theme }) => theme.bg0};
  overflow: hidden;
`

export const TooltipContainer = styled.div`
  background: rgba(18, 18, 18, 0.71);
  border-radius: 14px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.2px);
  -webkit-backdrop-filter: blur(6.2px);

  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .tooltip__heading {
    font-size: 14px;
  }

  .tooltip__volume {
    display: flex;
    flex-direction: column;

    &-title {
      font-size: 12px;
      font-weight: 300;
    }

    &-value {
      font-size: 14px;
      font-weight: 500;
    }
  }
`

export const ChartTitle = styled.h2`
  font-size: 14px;
  margin: 0;
  font-weight: 500;
  color: ${({ theme }) => theme.text2};
`
